// extracted by mini-css-extract-plugin
export default {"root":"_3uqlr","left":"C2nAl","left-side-item-wrapper":"_3cbk6","leftSideItemWrapper":"_3cbk6","right":"_89d0F","right-side-item-wrapper":"_3PMS2","rightSideItemWrapper":"_3PMS2"};